var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/to-buffer/~/isarray/index.js
// module id = J6PW
// module chunks = 3